var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icones / Loupe / Thin / Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accueil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-Accueil-Copy-3",
    transform: "translate(-1386.000000, -37.000000)",
    stroke: "#292927",
    strokeWidth: 1.59930616
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1380.941125, 31.941125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones-/-Loupe-/-Thin-/-Black",
    transform: "translate(24.000000, 24.000000) rotate(-45.000000) translate(-24.000000, -24.000000) "
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 17.2,
    r: 13.2003469
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 30,
    x2: 24,
    y2: 44.4,
    id: "Line-16"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifier);
export default __webpack_public_path__ + "static/media/icon-magnifier.8be22c233a5b57ccb6985ad63695a4ca.svg";
export { ForwardRef as ReactComponent };